import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingPaymentMethods: false,
  loadingPaymentMethod: false,
  loadingPaymentMethodCreate: false,
  loadingPaymentMethodUpdate: false,
  loadingPaymentMethodDelete: false,

  errorLoadingPaymentMethods: null,
  errorLoadingPaymentMethod: null,
  errorCreatingPaymentMethod: null,
  errorUpdatingPaymentMethod: null,
  errorDeletingPaymentMethod: null,

  paymentMethods: [],
  paymentMethod: null,

  serverStatus: null,
};

export const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState,
  reducers: {
    setLoadingPaymentMethods(state) {
      state.loadingPaymentMethods = true;
      state.errorLoadingPaymentMethods = null;
    },
    setLoadingPaymentMethod(state) {
      state.loadingPaymentMethod = true;
      state.errorLoadingPaymentMethod = null;
    },
    setLoadingPaymentMethodCreate(state) {
      state.loadingPaymentMethodCreate = true;
      state.errorCreatingPaymentMethod = null;
    },
    setLoadingPaymentMethodUpdate(state) {
      state.loadingPaymentMethodUpdate = true;
      state.errorUpdatingPaymentMethod = null;
    },
    setLoadingPaymentMethodDelete(state) {
      state.loadingPaymentMethodDelete = true;
      state.errorDeletingPaymentMethod = null;
    },

    setErrorLoadingPaymentMethods(state, { payload }) {
      state.loadingPaymentMethods = false;
      state.errorLoadingPaymentMethods = payload;
    },
    setErrorLoadingPaymentMethod(state, { payload }) {
      state.loadingPaymentMethod = false;
      state.errorLoadingPaymentMethod = payload;
    },
    setErrorCreatingPaymentMethod(state, { payload }) {
      state.loadingPaymentMethodCreate = false;
      state.errorCreatingPaymentMethod = payload;
    },
    setErrorUpdatingPaymentMethod(state, { payload }) {
      state.loadingPaymentMethodUpdate = false;
      state.errorUpdatingPaymentMethod = payload;
    },
    setErrorDeletingPaymentMethod(state, { payload }) {
      state.loadingPaymentMethodDelete = false;
      state.errorDeletingPaymentMethod = payload;
    },

    setPaymentMethods(state, { payload }) {
      state.loadingPaymentMethods = false;
      state.errorLoadingPaymentMethods = null;
      state.paymentMethods = payload;
    },

    setPaymentMethod(state, { payload }) {
      state.loadingPaymentMethod = false;
      state.errorLoadingPaymentMethod = null;
      state.paymentMethod = payload;
    },

    createPaymentMethodSuccess(state, { payload }) {
      state.paymentMethods = [payload, ...state.paymentMethods];
      state.loadingPaymentMethodCreate = false;
      state.errorCreatingPaymentMethod = null;
    },

    updatePaymentMethodSuccess(state, { payload }) {
      state.paymentMethods = state.paymentMethods.map((u) =>
        u.id === payload.id ? payload : u,
      );

      if (state.paymentMethod && state.paymentMethod.id === payload.id) {
        state.paymentMethod = payload;
      }

      state.loadingPaymentMethodUpdate = false;
      state.errorUpdatingPaymentMethod = null;
    },

    deletePaymentMethodSuccess(state, { payload: idToDelete }) {
      state.paymentMethods = state.paymentMethods.filter(
        (u) => u.id !== idToDelete,
      );

      if (state.paymentMethod && state.paymentMethod.id === idToDelete) {
        state.paymentMethod = null;
      }

      state.loadingPaymentMethodDelete = false;
      state.errorDeletingPaymentMethod = null;
    },

    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingPaymentMethods,
  setLoadingPaymentMethod,
  setLoadingPaymentMethodInfo,
  setLoadingPaymentMethodCreate,
  setLoadingPaymentMethodUpdate,
  setLoadingPaymentMethodDelete,

  setErrorLoadingPaymentMethods,
  setErrorLoadingPaymentMethod,
  setErrorLoadingPaymentMethodInfo,
  setErrorCreatingPaymentMethod,
  setErrorUpdatingPaymentMethod,
  setErrorDeletingPaymentMethod,

  setPaymentMethods,
  setPaymentMethod,
  createPaymentMethodSuccess,
  updatePaymentMethodSuccess,
  deletePaymentMethodSuccess,

  setServerResponseStatus,
} = paymentMethodSlice.actions;

export default paymentMethodSlice.reducer;

export const selectPaymentMethod = (state) => state.paymentMethod;
